<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage :page-titles="pageTitles" :hide-button="true" />
      <div
        class="mt-3 mb-1"
        v-if="empresaAtiva === null"
        v-class="row - option"
      >
        <span>Aguarde...</span>
      </div>
      <div v-if="empresaAtiva !== null" class="row-option">
        <b-form-checkbox
          v-model="empresaAtiva"
          switch
          class="mr-n2"
          @change="confirm"
        />
        <span v-if="empresaAtiva === true" class="ml-2">Empresa Ativada</span>
        <span v-else class="ml-2">Empresa Desativada</span>
      </div>
    </div>
    <b-modal
      v-model="openModalConfirmDisable"
      title="Tem certeza que deseja desativar a empresa?"
      title-class="font-18"
      @hide="closeModalDisable"
    >
      <p
        >Ao desativar a empresa somente você e os usuários indicados abaixo
        poderão efetuar login no CFObras e as funções serão limitadas.</p
      >

      <Multiselect
        v-model="usuariosPreservados"
        track-by="name"
        label="name"
        selected-label="Selecionado"
        deselect-label="Remover"
        select-label="Adicionar"
        placeholder="Usuários Preservados"
        :options="usuarios"
        close-on-select="false"
        multiple
      />
      <template v-slot:modal-footer>
        <b-button variant="light" @click="closeModalDisable">Não</b-button>
        <b-button variant="danger" @click="desativaEmpresa">Sim</b-button>
      </template>
    </b-modal>
    <b-modal
      v-model="openModalConfirmEnable"
      title="Tem certeza que deseja ativar a empresa?"
      title-class="font-18"
      @hide="closeModalEnable"
    >
      <p
        >Ao ativar a empresa os usuários terão as permissões restauradas e
        poderão efetuar login.</p
      >

      <template v-slot:modal-footer>
        <b-button variant="light" @click="closeModalEnable">Não</b-button>
        <b-button variant="danger" @click="ativaEmpresa">Sim</b-button>
      </template>
    </b-modal>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import alertMixin from '@/src/mixins/alertMixin'
import 'vue-select/dist/vue-select.css'
import Multiselect from 'vue-multiselect'
import serviceEmpresaObra from '@/src/services/serviceEmpresaObra'
export default {
  components: { Layout, HeaderPage, Multiselect },
  mixins: [alertMixin],
  data() {
    return {
      usuarios: [],
      usuariosPreservados: [],
      openModalConfirmDisable: false,
      openModalConfirmEnable: false,
      empresaAtiva: null,
      isLoading: false,
      pageTitles: {
        title: 'Desativar Empresa',
        subtitle: 'Desativar empresa temporariamente',
      },
    }
  },
  async mounted() {
    const user = this.$store.state.auth.currentUser.user
    const empresa = user.empresa_id

    this.usuarios = []
    const usuarios = await serviceEmpresaObra.detalhesUsuarios(empresa._id)

    for (let usuario of usuarios.data) {
      this.usuarios.push({
        value: usuario._id,
        name: `${usuario.nome} - ${usuario.funcao}`,
      })
    }

    this.usuarios.sort(function (a, b) {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    })

    if (empresa.ativo) {
      this.empresaAtiva = true
    } else {
      this.empresaAtiva = false
    }
  },

  methods: {
    confirm() {
      if (this.empresaAtiva) {
        this.openModalConfirmEnable = true
      } else {
        this.openModalConfirmDisable = true
      }
    },
    closeModalDisable() {
      this.openModalConfirmDisable = false
      this.empresaAtiva = true
    },
    closeModalEnable() {
      this.openModalConfirmEnable = false
      this.empresaAtiva = false
    },
    ativaEmpresa() {
      this.isLoading = true
      const user = this.$store.state.auth.currentUser.user
      const empresa = user.empresa_id
      serviceEmpresaObra
        .ativaEmpresa(empresa._id)
        .then((_res) => {
          this.isLoading = false
          this.openModalConfirmDisable = false
          this.empresaAtiva = false
          this.$bvToast.toast('Empresa ativada com sucesso.', {
            variant: 'success',
            autoHideDelay: 5000,
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          localStorage.clear()
          window.location.reload(true)
        })
        .catch((_err) => {
          this.isLoading = false
          this.openModalConfirmDisable = false
          this.empresaAtiva = true
          this.$bvToast.toast(
            'Ocorreu um erro ao ativar a empresa, tente novamente.',
            {
              variant: 'danger',
              autoHideDelay: 5000,
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
    },
    desativaEmpresa() {
      this.isLoading = true
      const user = this.$store.state.auth.currentUser.user
      const empresa = user.empresa_id
      const usuariosPreservados = this.usuariosPreservados.map(
        (usuario) => usuario.value
      )
      usuariosPreservados.push(user._id)
      serviceEmpresaObra
        .desativaEmpresa(empresa._id, {
          usuariosPreservados: usuariosPreservados,
          tornarFiliaisInativas: true,
        })
        .then((_res) => {
          this.isLoading = false
          this.openModalConfirmDisable = false
          this.empresaAtiva = false
          this.$bvToast.toast('Empresa desativada com sucesso.', {
            variant: 'success',
            autoHideDelay: 5000,
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          localStorage.clear()
          window.location.reload(true)
        })
        .catch((_err) => {
          this.isLoading = false
          this.openModalConfirmDisable = false
          this.empresaAtiva = true
          this.$bvToast.toast(
            'Ocorreu um erro ao desativar a empresa, tente novamente.',
            {
              variant: 'danger',
              autoHideDelay: 5000,
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
    },
  },
}
</script>

<style>
.row-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
}
</style>

<style src="../style.scss" lang="scss"></style>
